import { NATIVE_TOKEN_IDENTIFIER } from '@cronos-app/sdk';
import { currentWallet, useDesiredChain } from '@cronos-app/wallet';
import type { Token } from '@ui/config/token';
import { TOKEN_CONFIG_MAP } from '@ui/config/token';
import { isNormalToken } from '@ui/config/token/types';
import { getSDK } from '@ui/utils';
import { useCallback } from 'react';

import { useGlobalChainLayer } from './useGlobalChainLayer';

export const useWatchAsset = () => {
  const chainLayer = useGlobalChainLayer();
  const desiredChain = useDesiredChain(chainLayer);
  const isConnected = currentWallet.useIsConnected();
  const hasProvider = currentWallet.useHasProvider;
  const isDefiWallet =
    typeof window !== 'undefined' &&
    window.navigator.userAgent.includes('DeFiWallet');

  const canWatch = !isDefiWallet && hasProvider;

  const watchAsset = useCallback(
    async ({ token }: { token: Token }) => {
      /**
       * Only metamask support watch asset
       */
      if (!canWatch || !isConnected || !isNormalToken(token)) return;

      const tokenInfo = TOKEN_CONFIG_MAP[desiredChain][token];
      const tokenAddress = tokenInfo.address;

      if (tokenAddress === NATIVE_TOKEN_IDENTIFIER) {
        return;
      }

      const sdk = getSDK(desiredChain);
      const erc20 = sdk.getERC20(tokenAddress);

      const tokenSymbol = await erc20.symbol();

      return currentWallet.watchAsset({
        symbol: tokenSymbol,
        address: tokenAddress,
        decimals: tokenInfo.decimals,
        image: '',
      });
    },
    [canWatch, desiredChain, isConnected],
  );

  return {
    canWatch,
    watchAsset,
  };
};
